var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        fullscreen: _vm.$vuetify.breakpoint.mdAndDown,
        persistent: "",
        "content-class": "service-logs-dialog",
        "max-width": "90%",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "SecondaryBtn",
                _vm._g({ attrs: { icon: "event_note", small: "" } }, on),
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("Button.ExecutionLogs")) +
                      "\n    "
                  ),
                ]
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _vm._v(" "),
      _vm.dialog
        ? [
            _c(
              "v-flex",
              [
                _c(
                  "v-card",
                  { attrs: { flat: "", dark: "" } },
                  [
                    _c(
                      "v-toolbar",
                      { attrs: { dark: "", color: "primary" } },
                      [
                        _c("v-toolbar-title", [_vm._v("Execution Logs")]),
                        _vm._v(" "),
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "", dark: "" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.close()
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("close")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              { staticStyle: { overflow: "auto" } },
              [
                _vm.dialog
                  ? _c(
                      "v-card",
                      { attrs: { dark: "" } },
                      [
                        _c(
                          "v-layout",
                          { attrs: { row: "" } },
                          [
                            _c(
                              "v-flex",
                              {
                                staticStyle: { padding: "32px 32px 0 32px" },
                                attrs: { md6: "" },
                              },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    readonly: "",
                                    label: "Service",
                                    value: _vm.service.DisplayName,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          {
                            staticStyle: { padding: "0 32px 0 32px" },
                            attrs: { row: "" },
                          },
                          [
                            _c(
                              "v-flex",
                              { attrs: { md12: "", lg12: "" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    label: "Search Logs",
                                    placeholder: "Enter search terms",
                                  },
                                  model: {
                                    value: _vm.searchTerm,
                                    callback: function ($$v) {
                                      _vm.searchTerm = $$v
                                    },
                                    expression: "searchTerm",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          {
                            staticStyle: { "padding-left": "32px" },
                            attrs: { row: "" },
                          },
                          [
                            _c(
                              "v-flex",
                              { attrs: { md6: "", lg6: "" } },
                              [
                                _c("v-autocomplete", {
                                  attrs: {
                                    clearable: "",
                                    items: _vm.tenants,
                                    "item-text": "RoleName",
                                    "return-object": "",
                                    placeholder: "Select Tenant",
                                  },
                                  model: {
                                    value: _vm.selectedTenant,
                                    callback: function ($$v) {
                                      _vm.selectedTenant = $$v
                                    },
                                    expression: "selectedTenant",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          [
                            _c(
                              "v-flex",
                              {
                                staticStyle: { "padding-left": "32px" },
                                attrs: { xs12: "", sm8: "", md3: "", lg3: "" },
                              },
                              [
                                _c(
                                  "v-menu",
                                  {
                                    attrs: {
                                      "close-on-content-click": false,
                                      "full-width": "",
                                      "max-width": "290",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c(
                                                "v-text-field",
                                                _vm._g(
                                                  {
                                                    attrs: {
                                                      label:
                                                        "Select Log Start Date",
                                                      readonly: "",
                                                      hint: "Enter a Valid Date",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.computedStartDate,
                                                      callback: function ($$v) {
                                                        _vm.computedStartDate =
                                                          $$v
                                                      },
                                                      expression:
                                                        "computedStartDate",
                                                    },
                                                  },
                                                  on
                                                )
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1988017906
                                    ),
                                    model: {
                                      value: _vm.startDateMenu,
                                      callback: function ($$v) {
                                        _vm.startDateMenu = $$v
                                      },
                                      expression: "startDateMenu",
                                    },
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("v-date-picker", {
                                      attrs: {
                                        min: _vm.getMinStartDate,
                                        max: _vm.computedEndDate,
                                      },
                                      on: {
                                        change: function ($event) {
                                          _vm.startDateMenu = false
                                        },
                                      },
                                      model: {
                                        value: _vm.startDate,
                                        callback: function ($$v) {
                                          _vm.startDate = $$v
                                        },
                                        expression: "startDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              {
                                staticStyle: { "margin-left": "16px" },
                                attrs: { xs12: "", sm8: "", md3: "", lg3: "" },
                              },
                              [
                                _c(
                                  "v-menu",
                                  {
                                    attrs: {
                                      "close-on-content-click": false,
                                      "full-width": "",
                                      "max-width": "290",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c(
                                                "v-text-field",
                                                _vm._g(
                                                  {
                                                    attrs: {
                                                      value:
                                                        _vm.computedEndDate,
                                                      label:
                                                        "Select Log End Date",
                                                      readonly: "",
                                                      hint: "Enter a Valid Date",
                                                    },
                                                  },
                                                  on
                                                )
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      22743715
                                    ),
                                    model: {
                                      value: _vm.endDateMenu,
                                      callback: function ($$v) {
                                        _vm.endDateMenu = $$v
                                      },
                                      expression: "endDateMenu",
                                    },
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("v-date-picker", {
                                      attrs: {
                                        min: _vm.computedStartDate,
                                        max: _vm.getMaxEndDate,
                                      },
                                      on: {
                                        change: function ($event) {
                                          _vm.endDateMenu = false
                                        },
                                      },
                                      model: {
                                        value: _vm.endDate,
                                        callback: function ($$v) {
                                          _vm.endDate = $$v
                                        },
                                        expression: "endDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              {
                                staticStyle: { "padding-left": "10px" },
                                attrs: { xs12: "", sm8: "", md3: "", lg3: "" },
                              },
                              [
                                _c("PresetButtons", {
                                  attrs: {
                                    direction: "top",
                                    "min-date-bound": _vm.minDateBound,
                                    "max-date-bound": _vm.maxDateBound,
                                    "date-range-shortcuts":
                                      _vm.dateRangeShortcuts,
                                  },
                                  on: { input: _vm.onDatePresetSelected },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          { staticStyle: { "margin-left": "32px" } },
                          [
                            _c(
                              "v-flex",
                              { staticStyle: { "flex-grow": "0" } },
                              [
                                _c("v-checkbox", {
                                  attrs: { label: "Errors only" },
                                  model: {
                                    value: _vm.showLogsIfHasError,
                                    callback: function ($$v) {
                                      _vm.showLogsIfHasError = $$v
                                    },
                                    expression: "showLogsIfHasError",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              {
                                staticClass: "ml-4",
                                staticStyle: { "flex-grow": "0" },
                              },
                              [
                                _c("v-checkbox", {
                                  attrs: { label: "No test runs" },
                                  model: {
                                    value: _vm.showLogsIfNotTestRun,
                                    callback: function ($$v) {
                                      _vm.showLogsIfNotTestRun = $$v
                                    },
                                    expression: "showLogsIfNotTestRun",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              {
                                staticClass: "ml-4",
                                staticStyle: { "flex-grow": "0" },
                              },
                              [
                                _c("v-checkbox", {
                                  attrs: { label: "No file format checks" },
                                  model: {
                                    value: _vm.showLogsIfNotSniff,
                                    callback: function ($$v) {
                                      _vm.showLogsIfNotSniff = $$v
                                    },
                                    expression: "showLogsIfNotSniff",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          { attrs: { "pl-4": "" } },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "info", depressed: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.fetchLogs()
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("Button.Search")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "error", depressed: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.clearFilters()
                                  },
                                },
                              },
                              [
                                _c("v-icon", [_vm._v("clear")]),
                                _vm._v(
                                  _vm._s(_vm.$t("Button.ClearFilters")) +
                                    "\n          "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-card",
                  [
                    _vm.isLoading
                      ? _c(
                          "v-layout",
                          { staticClass: "py-5" },
                          [
                            _c("PageLoader", {
                              attrs: { resourceName: "Logs" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dialog
                      ? _c("ServiceUserLogs", {
                          ref: "serviceLogsComponent",
                          attrs: {
                            loading: _vm.isLoading,
                            startDate: _vm.computedStartDate,
                            endDate: _vm.computedEndDate,
                            searchTerm: _vm.searchTerm,
                            tenant: _vm.selectedTenant,
                            showLogsIfHasError: _vm.showLogsIfHasError,
                            showLogsIfNotTestRun: _vm.showLogsIfNotTestRun,
                            showLogsIfNotSniff: _vm.showLogsIfNotSniff,
                            serviceName: _vm.service.CapabilityServiceName,
                          },
                          on: {
                            "update:loading": function ($event) {
                              _vm.isLoading = $event
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              [
                _c(
                  "v-card",
                  { staticStyle: { "border-top": "1px solid #dddddd" } },
                  [
                    _c(
                      "v-card-actions",
                      [
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { color: "secondary", outline: "" },
                            on: {
                              click: function ($event) {
                                return _vm.close()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }